import { LabelSearchTableActionType as Action } from '@aibees/elephant/feature/search-list-card/types';
import { Icon, PopoverListButtonItem } from '@aibees/shared/components';

export const createListSearchActionMenuItems = (
  isDisabled: (actionType: Action) => boolean
): PopoverListButtonItem[] => [
  {
    label: 'Include',
    key: Action.Include,
    icon: <Icon name="add-circle-outlined" size={18} color="primary.500" />,
    disabled: isDisabled(Action.Include),
  },
  {
    label: 'Exclude',
    key: Action.Exclude,
    icon: <Icon name="stop-sign" size={18} color="error.500" />,
    disabled: isDisabled(Action.Exclude),
  },
  {
    label: 'Include (AND)',
    key: Action.IncludeAnd,
    icon: <Icon name="add-task" size={18} color="warning.500" />,
    disabled: isDisabled(Action.IncludeAnd),
  },
];
